import materialReviewContent from './content/materials-20261018.json';
import visualReviewContent from './content/materials-20261020.json';

// Keep review packages offline while preserving the original blank layout mode.
export const isLayoutDemo = process.env.REACT_APP_LAYOUT_DEMO === '1';
export const isMaterialReview = isLayoutDemo && process.env.REACT_APP_MATERIAL_REVIEW === '1';
export const isBlankLayoutDemo = isLayoutDemo && !isMaterialReview;
export const publicAsset = (path) => `${process.env.PUBLIC_URL || ''}/${path.replace(/^\/+/, '')}`;
const blankDemoContent = {
  products: [
    { slug: 'learn', name: 'Learn', status: 'available' },
    { slug: 'nexus', name: 'Agentec Nexus', status: 'available' },
    { slug: 'agentec-one', name: 'AgentecOne', status: 'available' }
  ],
  film: {}
};
export const demoContent = isMaterialReview ? (process.env.REACT_APP_REVIEW_REVISION === '20261020' ? visualReviewContent : materialReviewContent) : blankDemoContent;
